import Api from "../common/Api";
import {RdmpCondModel} from "app/model/rp/RdmpCondModel";
import {ScnroModel} from "app/model/rp/ScnroModel";
import {ApiUrlUtil} from "app/utils/apiUrlUtil";
import { RdmpAnlsReturnModel } from "app/model/rp/RdmpAnlsModel";
import {GoalModel} from "app/model/rp/GoalModel";

export class RdmpCondService extends Api {

  private static service: RdmpCondService;
  private static GET_URL: string = process.env['REACT_APP_URL_RP'] + '/rdmp/detail';
  private static GET_QNT_URL: string = process.env['REACT_APP_URL_RP'] + '/qnt/qntDetail'
  private static INSERT_URL: string = process.env['REACT_APP_URL_RP'] + '/rdmp/insert';
  private static GET_LATEST_SCNRO_URL: string = process.env['REACT_APP_URL_RP'] + '/scnro/detailLatest';
  private static GET_REGIST_SCNRO_URL: string = process.env['REACT_APP_URL_RP'] + '/scnro/detail-regist';
  private static COUNT_URL: string = process.env['REACT_APP_URL_RP'] + '/rdmp/rdmpCount';
  private static YEARLY_QNT_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/yearlyQnt';
  private static GET_PERCENT_URL: string = process.env['REACT_APP_URL_RP'] + '/rdmp/percent';

  public static getInstance(): RdmpCondService {
    if(!RdmpCondService.service) {
      RdmpCondService.service = new RdmpCondService();
    }
    return RdmpCondService.service;
  }

  public async getPrevKepcoPwrUse() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_RP + "/rdmp/prevPwrUse");
    return super.get<RdmpAnlsReturnModel>(url);
  }

  public async getThisYyGoal() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_RP + "/goal");
    return super.get<GoalModel>(url);
  }

  public async saveThisYyGoal(form : GoalModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_RP + "/goal");
    return super.post<GoalModel>(url, form);
  }

  /**
   * @description smcnCert 이행수단 실적 사용 및 수정 완료 2025.08.06
   */
  public async getRdmpCond() {
    return await super.get<RdmpCondModel[]>(RdmpCondService.GET_URL);
  }

  /**
   * @description smcnCert 이행수단 실적 사용 및 수정 완료 2025.08.06
   */
  public async getQntDetail() {
    return await super.get<any>(RdmpCondService.GET_QNT_URL);
  }

  public async insertRdmpCond(rdmpCond: RdmpCondModel) {
    return await super.post<RdmpCondModel>(RdmpCondService.INSERT_URL, rdmpCond);
  }

  // 로드맵 메인페이지 최근시나리오
  public async getLatestScnro() {
    return await super.get<ScnroModel>(RdmpCondService.GET_LATEST_SCNRO_URL);
  }

  // 이행수단 안씀
  // useYn='Y'인 시나리오 조회
  public async getRegistScnro() {
    return await super.get<ScnroModel>(RdmpCondService.GET_REGIST_SCNRO_URL);
  }

  // admin 대시보드: RE100 참여 현황
  public async getRdmpCount() {
    return await super.get<any>(RdmpCondService.COUNT_URL);
  }

  public async getYearlyQnt(year: string) {
    return await super.get<any>(RdmpCondService.YEARLY_QNT_URL, {year: year});
  }

  // 퍼센트
  public async getPercent(year: string) {
    return await super.get<any>(RdmpCondService.GET_PERCENT_URL, {year: year});
  }
}